/**
 * Class which can generate an ics file and open or download it. Used for event pages // add to calendar
 */
export class CreateCalendar {

	constructor() {
		if (navigator.userAgent.indexOf('MSIE') > -1 && navigator.userAgent.indexOf('MSIE 10') === -1) {
			console.log('Unsupported Browser');
			return;
		}

		this.SEPARATOR = (navigator.appVersion.indexOf('Win') !== -1) ? '\r\n' : '\n';
		this.calendarEvents = [];
		this.calendarStart = [
			'BEGIN:VCALENDAR',
			'VERSION:2.0'
		].join(this.SEPARATOR);
		this.calendarEnd = this.SEPARATOR + 'END:VCALENDAR';
	}

	/**
	 * Returns events array
	 * @return {array} Events
	 */
	events() {
		return this.calendarEvents;
	}

	/**
	 * Returns calendar
	 * @return {string} Calendar in iCalendar format
	 */
	calendar() {
		return this.calendarStart + this.SEPARATOR + this.calendarEvents.join(this.SEPARATOR) + this.calendarEnd;
	}

	/**
	 * Add event to the calendar
	 * @param  {string} subject     Subject/Title of event
	 * @param  {string} description Description of event
	 * @param  {string} location    Location of event
	 * @param  {string} begin       Beginning date of event
	 * @param  {string} stop        Ending date of event
	 */
	addEvent(subject, description, location, begin, stop) {
		// I'm not in the mood to make these optional... So they are all required
		if (typeof subject === 'undefined' ||
			typeof description === 'undefined' ||
			typeof location === 'undefined' ||
			typeof begin === 'undefined' ||
			typeof stop === 'undefined'
		) {
			return false;
		}

		const startDate = new Date(begin),
			endDate = new Date(stop),

			startYear = ('0000' + (startDate.getFullYear().toString())).slice(-4),
			startMonth = ('00' + ((startDate.getMonth() + 1).toString())).slice(-2),
			startDay = ('00' + ((startDate.getDate()).toString())).slice(-2),
			startHours = ('00' + (startDate.getHours().toString())).slice(-2),
			startMinutes = ('00' + (startDate.getMinutes().toString())).slice(-2),
			startSeconds = ('00' + (startDate.getMinutes().toString())).slice(-2),

			endYear = ('0000' + (endDate.getFullYear().toString())).slice(-4),
			endMonth = ('00' + ((endDate.getMonth() + 1).toString())).slice(-2),
			endDay = ('00' + ((endDate.getDate()).toString())).slice(-2),
			endHours = ('00' + (endDate.getHours().toString())).slice(-2),
			endMinutes = ('00' + (endDate.getMinutes().toString())).slice(-2),
			endSeconds = ('00' + (endDate.getMinutes().toString())).slice(-2);

		// Since some calendars don't add 0 second events, we need to remove time if there is none...
		let startTime = '',
			endTime = '';

		if (startMinutes + startSeconds + endMinutes + endSeconds !== 0) {
			startTime = 'T' + startHours + startMinutes + startSeconds;
			endTime = 'T' + endHours + endMinutes + endSeconds;
		}

		const start = startYear + startMonth + startDay + startTime,
			end = endYear + endMonth + endDay + endTime;

		const calendarEvent = [
			'BEGIN:VEVENT',
			'CLASS:PUBLIC',
			'DESCRIPTION:' + description,
			'DTSTART;VALUE=DATE:' + start,
			'DTEND;VALUE=DATE:' + end,
			'LOCATION:' + location,
			'SUMMARY;LANGUAGE=en-us:' + subject,
			'TRANSP:TRANSPARENT',
			'END:VEVENT'
		].join(this.SEPARATOR);

		this.calendarEvents.push(calendarEvent);
		return calendarEvent;
	}

	isIE() {
		if (typeof window !== 'undefined' &&
			window.navigator.msSaveOrOpenBlob &&
			window.Blob
		) {
			return true;
		}
	}

	/**
	 * Generated and downloads the ics file
	 * @returns {boolean | void}
	 */
	download() {
		if (this.calendarEvents.length < 1) {
			return false;
		}

		const calendar = this.calendar();

		if (this.isIE()) {
			const filename = 'download.ics';
			const blob = new Blob([calendar], {type: 'text/calendar;charset=utf-8'});
			window.navigator.msSaveOrOpenBlob(blob, filename);
		} else {
			window.open('data:text/calendar;charset=utf8,' + escape(calendar));
		}
	}
}
